import React from 'react';
import { DateTime } from 'luxon';

const DateCell = (fieldName) => ({data}) => {
    const value = data[fieldName];

    if (!value)
        return (<></>);

    const parsed = DateTime.fromISO(value);

    return (
        `${parsed.toLocaleString()}`
    );
};

export default DateCell;